import {PaginationState} from "app/shared/pagination/pagination.model";
import {
  AdministrativeUnitOverviewFilterDto,
  AdministrativeUnitViewRow
} from "app/edozvola/administrative-unit-overview/model/administrative-unit-overview.model";
import axios from "axios";

export const fetchAdministrativeUnitOverview = async (pagination: PaginationState, filterDto: AdministrativeUnitOverviewFilterDto): Promise<AdministrativeUnitViewRow[]> => {
  return await new Promise((resolve, reject) => {
    axios.post(`/api/administrative-unit-overview?page=${pagination.page}&size=${pagination.size}&column=${pagination.column}&direction=${pagination.direction}`, filterDto)
      .then(res => {
        resolve(res.data);
      })
      .catch(error => {
        reject(error);
      })
  });
};
